import { HeadquarterCode } from '../enum/HeadquaterCode';

export const headquarterWorldRegionsCodes = [
  HeadquarterCode.AsiaPacific,
  HeadquarterCode.Europe,
  HeadquarterCode.LatinAmerica,
  HeadquarterCode.MiddleEastAndAfrica,
  HeadquarterCode.NorthAmerica,
];
